const offcanvasContainer = $('#offcanvas');
const offcanvasCloseButton = offcanvasContainer.find('.offcanvas-close-toggle');
const offcanvasCategoryCloseButton = '#offcanvas-category .offcanvas-close-toggle';
const offcanvasOpenButton = $('.header-offcanvas-toggle');

export function openOffcanvasCategory() {
  $('body').addClass('category-open');
}

export function closeOffcanvasCategory() {
  $('body').removeClass('category-open');
}

export function openOffcanvas(e) {
  $('body').addClass('megamenu-open');
  if (e.currentTarget.dataset.overlay === '1') $('body').addClass('offcanvas-overlay');
  $('#backdrop').addClass('is-visible');
  offcanvasContainer.addClass('is-animate is-open');
}

export function closeOffcanvas() {
  $('body').removeClass('megamenu-open');
  $('body').removeClass('offcanvas-overlay');
  $('#backdrop').removeClass('is-visible');
  offcanvasContainer.removeClass('is-open');
}

$(() => {
  $(offcanvasOpenButton).on('click', e => openOffcanvas(e));
  $(offcanvasCloseButton).on('click', closeOffcanvas);
  $(offcanvasCategoryCloseButton).on('click', closeOffcanvasCategory);
});

beforeWindowWidthResizeFunctions.push(() => {
  if (windowSizeHelper.isMobileToDesktopResize()) {
    closeOffcanvas();
  }
});

document.addEventListener('DOMContentLoaded', () => {
  $(document).on('click', '#backdrop', closeOffcanvas);

  $(document).on('click', '.offcanvas-catalog-toggle', (event) => {
    const { currentTarget } = event;
    const isCollapsed = $(currentTarget).attr('aria-expanded') === 'true';
    const targetContainer = $(currentTarget).attr('aria-controls');

    if (isCollapsed) {
      $(currentTarget).attr('aria-expanded', false);
      $(`#${targetContainer}`).slideToggle();
      return;
    }

    $(currentTarget).attr('aria-expanded', true);
    $(`#${targetContainer}`).slideToggle();
  });
});
